import fileSaver from 'file-saver';
import globals from '../../../globals/communityGlobals';
import axios from '../../../utils/axios';
import { HTTP_METHOD } from '../../../actions/constants/methods';

const tppApiUrl = globals.urls.tppApiUrl;

export const downloadS1Link = async tenantCode => {
  const result = await axios({
    baseURL: tppApiUrl,
    method: HTTP_METHOD.Get,
    url: `/DownloadS1LinkInstaller?tenantCode=${tenantCode}`,
    responseType: 'blob',
  });

  fileSaver.saveAs(new Blob([result.data], { type: 'application/zip' }), 'S1LinkInstaller.zip');
};
